<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.873"
      height="17.873"
      viewBox="0 0 17.873 17.873"
      class="scaling-svg"
    >
      <g id="Group_196" data-name="Group 196" transform="translate(-390.887 -639.073)">
        <g id="_24_Plus" data-name="24 Plus" transform="translate(390.887 639.073)">
          <path
            id="Fill_16"
            data-name="Fill 16"
            d="M8.936,0a8.936,8.936,0,1,0,8.936,8.936A8.939,8.939,0,0,0,8.936,0Z"
            transform="translate(0 0)"
            fill="#feb200"
          />
        </g>
        <path
          id="Path"
          d="M7.447,4.841H4.841V7.447a.745.745,0,0,1-1.489,0V4.841H.745a.745.745,0,1,1,0-1.489H3.351V.745a.745.745,0,0,1,1.489,0V3.351H7.447a.745.745,0,1,1,0,1.489Z"
          transform="translate(395.728 643.913)"
          fill="#3f3d4c"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class YellowPlusIcon extends Vue {}
</script>

<style>
</style>
